import { render, staticRenderFns } from "./FormRoles.vue?vue&type=template&id=6ac33d52&scoped=true&"
import script from "./FormRoles.vue?vue&type=script&lang=js&"
export * from "./FormRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac33d52",
  null
  
)

export default component.exports